module.exports = __webpack_public_path__ + "static/media/search-restaurant.78bf7118.svg";